import React from 'react';
import headerGraphic from '../assets/images/backgrounds/header-graphic.webp';
import FAQHeader from '../pageComponents/faq/FAQHeader';
import FAQList from '../pageComponents/faq/FAQList';
import SignUpBanner from '../components/SignUpBanner';

export default function FAQPage() {
  return (
    <section
      className='relative min-h-screen flex flex-col items-center justify-center 3xl:bg-contain bg-top bg-no-repeat bg-auto px-6'
      style={{
        backgroundImage: `url(${headerGraphic})`,
      }}
    >
      <div className='container mx-auto py-26 max-w-5xl mt-16'>
        <FAQHeader />
        <FAQList />
      </div>
      <SignUpBanner />
    </section>
  );
}
